/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { updatePath } from "../../utils/Routes";
import { bioChemMerge } from "../../actions/biochem";
import ChemBioPending from "../Common/ChemBioPending/ChemBioPending";
import Hmc from "../Components/Biochemistry/Hmc";
import "../Components/Biochemistry/Biochem.css";

const AntTabs = withStyles({
  root: {
    backgroundColor: "#F4F5F7",
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#494B83",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 160,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontSize: "14px",
    lineHeight: "24px",
    color: "#6B778C",
    fontFamily: ["Roboto Bold"].join(","),
    "&:hover": {
      color: "#494B83",
      opacity: 1,
    },
    "&$selected": {
      color: "#494B83",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#494B83",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  chem: {
    backgroundColor: "#F4F5F7",
  },
}));

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`biochem-tabpanel-${index}`}
      aria-labelledby={`biochem-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

TabPanel.defaultProps = {
  children: null,
};

function a11yProps(index) {
  return {
    id: `biochem-tab-${index}`,
    "aria-controls": `biochem-tabpanel-${index}`,
  };
}

export default function BioChemTab() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const history = useHistory();
  const page = "biochem";
  const index = undefined;
  const currentPath = undefined;

  const handleChange = useCallback((event, newValue) => {
    // Depending on the value of the tab, update the path
    updatePath(currentPath, newValue, page, setValue, history);
    // Update the state
    setValue(newValue);
  }, [history, currentPath]);

  useEffect(() => {
    const path = window.location.pathname;
    // On refresh, makes sure the state is set correctly
    updatePath(path, index, page, setValue, history);

    // Handles the case when the back button on the browser is clicked
    const unlisten = history.listen((location, action) => {
      if (action === "POP") {
        updatePath(location.pathname, index, page, setValue, history);
      }
    });
    // Cleanup subscription on component unmount
    return () => {
      unlisten();
    };
  }, [history, index]);

  // const {} = props;
  // const toggleHmcData = () => {
  //   setShowData((state) => !state);
  //   // setShowData(current => !current);
  // };
  // ^ already commented out prior to 1/12/22

  return (
    <div className={classes.root}>
      <div className={classes.biochem}>
        <AntTabs value={value} onChange={handleChange} aria-label="ant tabs">
          <AntTab label="Pending" {...a11yProps(0)} />
          <AntTab label="HMC" {...a11yProps(1)} />
        </AntTabs>

        <TabPanel value={value} index={0}>
          <div className="dropzone-wrapper biochemGeneral__Pending">
            <ChemBioPending
              getPendingResults={bioChemMerge}
              showSearch={false}
            />
          </div>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <div>
            <Hmc />
          </div>
        </TabPanel>
      </div>
    </div>
  );
}
